import React, { useCallback } from 'react'
import Link from 'redux-first-router-link'
import { useSelector } from 'react-redux'
import {
  inbox as InboxIcon,
  channel as ChannelIcon,
} from 'assets/icons/groove/v2'
import { doOpenMainPage } from 'actions/pages'
import { DRAWER_TYPE_CHANNELS_ADD } from 'ducks/drawers/types'
import { useDrawer } from 'ducks/drawers/hooks'
import { selectCurrentUserIsAdminOrOwner } from 'ducks/currentUser'
import ButtonWithMenu from '../ButtonWithMenu'

const toMainPage = doOpenMainPage()

const CentralizeMenu = ({ onClose }) => {
  const isManager = useSelector(selectCurrentUserIsAdminOrOwner)

  const { openDrawer } = useDrawer({
    type: DRAWER_TYPE_CHANNELS_ADD,
  })

  const createNewChannel = useCallback(
    () => {
      onClose()
      openDrawer('new')
    },
    [openDrawer, onClose]
  )
  return (
    <ButtonWithMenu.Menu className="centralizeMenu">
      <ButtonWithMenu.Menu.Item
        icon={<InboxIcon />}
        title="Conversations"
        copy="Browse all conversations from email, social & live chat."
        as={Link}
        to={toMainPage}
        onClick={onClose}
      />
      {isManager && (
        <ButtonWithMenu.Menu.Item
          title="Add more channels"
          copy="Connect a help widget, social, live chat & more."
          icon={<ChannelIcon />}
          onClick={createNewChannel}
          as="button"
        />
      )}
    </ButtonWithMenu.Menu>
  )
}

export default CentralizeMenu
